<template>
  <div class="newaddress">
    <div class="newaddress_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="back()"
      />
      <div class="my">新增收货地址</div>
    </div>
    <div class="newaddress_bottom">
      <van-form @submit="onSubmit">
        <div class="people">
          <div class="people_text">收货人</div>
          <van-field
            v-model="form.consignee"
            placeholder="请输入收货人姓名"
            class="consignee"
            :rules="[{ required: true }]"
            maxlength="10"
            show-word-limit
          ></van-field>
        </div>
        <div class="people">
          <div class="people_text">手机号</div>
          <van-field
            v-model="form.phone"
            type="tel"
            placeholder="请输入手机号"
            class="consignee"
            :rules="[
              { required: true },
              {
                pattern:
                  /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/,
                message: '手机号码格式不正确',
              },
            ]"
          />
        </div>
        <div class="people">
          <div class="people_text">所在地区</div>
          <van-field
            readonly
            clickable
            name="area"
            v-model="form.fieldValue"
            placeholder="点击选择省市区"
            @click="showArea = true"
            class="consignee"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-cascader
              v-model="cascaderValue"
              title="请选择所在地区"
              :options="options"
              @close="showArea = false"
              @finish="onFinish"
              :field-names="fieldNames"
            />
          </van-popup>
        </div>
        <div class="people">
          <div class="people_text">详细地址</div>
          <van-field
            v-model="form.detailAddress"
            rows="2"
            autosize
            type="textarea"
            maxlength="20"
            placeholder="请输入详细地址"
            show-word-limit
            class="consignee"
            style="height: 90px"
            :rules="[{ required: true }]"
          />
        </div>
        <div class="people">
          <div class="people_text">邮编</div>
          <van-field
            v-model="form.postalCode"
            placeholder="请输入邮编"
            class="consignee"
            :rules="[
              { required: true },
              {
                pattern: /^\d{6}$/,
                message: '邮编格式不正确',
              },
            ]"
          />
        </div>
        <div class="people">
          <div class="people_text">设为默认地址</div>
          <van-field name="switch">
            <template #input>
              <van-switch v-model="switchChecked" size="20" />
            </template>
          </van-field>
        </div>
        <div class="newaddress_page">
          <van-button round block type="info" class="obt" native-type="submit"
            >保存</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "newaddress",
  data() {
    return {
      valueTest: "",
      valueTest2: "",
      id: "",
      form: {
        consignee: "",
        phone: "",
        fieldValue: "",
        postalCode: "",
        detailAddress: "",
        // 市
        cityCode: "",
        cityName: "",
        // 区
        districtCode: "",
        districtName: "",
        // 省
        provinceCode: "",
        provinceName: "",
        // 街道
        streetCode: "",
        streetName: "",
      },
      aaa: "",
      cascaderValue: "",
      showArea: false,
      fieldNames: {
        text: "name",
        value: "code",
        children: "childList",
      },
      options: [],
      switchChecked: false,
      userId: "",
      data: "",
    };
  },
  created() {
    this.id = this.$route.query.item;
    this.getRegion();
    this.data = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = this.data.user.id;
  },
  methods: {
    back() {
      window.history.go(-1);
    },
    onFinish({ selectedOptions }) {
      this.showArea = false;
      this.form.fieldValue = selectedOptions.map((option) => option.name);
      this.aaa = selectedOptions.map((option) => option.code);
      this.form.cityCode = this.aaa[1];
      this.form.cityName = this.form.fieldValue[1];
      this.form.districtCode = this.aaa[2];
      this.form.districtName = this.form.fieldValue[2];
      this.form.provinceCode = this.aaa[0];
      this.form.provinceName = this.form.fieldValue[0];
      this.form.streetCode = this.aaa[3];
      this.form.streetName = this.form.fieldValue[3];
    },
    async onSubmit() {
      const res = await this.$apis.addressServe.setSave({
        cityCode: this.form.cityCode,
        cityName: this.form.cityName,
        consignee: this.form.consignee,
        createTime: "",
        detailAddress: this.form.detailAddress,
        districtCode: this.form.districtCode,
        districtName: this.form.districtName,
        id: this.id,
        isDefault: this.switchChecked,
        phone: this.form.phone,
        postalCode: this.form.postalCode,
        provinceCode: this.form.provinceCode,
        provinceName: this.form.provinceName,
        streetCode: this.form.streetCode,
        streetName: this.form.streetName,
        userId: this.userId,
      });
      if (res.resultCode !== "200") {
        Toast(res.resultDesc);
        return;
      } else {
        Toast("保存成功");
        this.back()
      }
    },
    async getRegion() {
      const res = await this.$apis.addressServe.getRegion();
      this.options = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.newaddress {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .newaddress_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 150px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }
    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }
  .newaddress_bottom {
    width: 94%;
    height: 100%;
    margin: 12px auto;
    background: #fff;
    border-radius: 8px 8px 8px 8px;
    overflow: hidden;
    .people {
      display: flex;
      margin-top: 20px;
      &:nth-last-child(1) {
        margin-bottom: 20px;
      }
      .people_text {
        width: 140px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 50px;
        text-align: left;
        margin-left: 10px;
      }
      .consignee {
        background: #f9f9f9;
        border-radius: 6px 6px 6px 6px;
        margin: 0px 15px 0px -25px;
      }
    }
    .newaddress_page {
      width: 100%;
      height: 74px;
      .obt {
        margin: 14px auto;
        width: 94%;
        background: #4979f1;
        border-radius: 21px 21px 21px 21px;
        border: none;
      }
    }
  }
}
</style>